import { render, staticRenderFns } from "./IconPlayOutline.vue?vue&type=template&id=2987a0c2"
import script from "./IconPlayOutline.vue?vue&type=script&lang=js"
export * from "./IconPlayOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports